import { PlugZap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { F } from "@/components/ajustes/Field";

export const WhatsappTab = ({ s, sec, busy, test, outlets, webhookUrl }) => (
  <>
    <F label="Access token (WhatsApp Cloud API)">
      <Input type="password" value={s.whatsapp?.access_token || ""} onChange={(e) => sec("whatsapp", "access_token", e.target.value)} data-testid="wa-token-input" />
    </F>
    <F label="Phone Number ID"><Input value={s.whatsapp?.phone_number_id || ""} onChange={(e) => sec("whatsapp", "phone_number_id", e.target.value)} data-testid="wa-phone-input" /></F>
    <F label="Destinatario / lista de difusión por defecto" hint="Número en formato internacional, ej.: 18091234567">
      <Input value={s.whatsapp?.default_recipient || ""} onChange={(e) => sec("whatsapp", "default_recipient", e.target.value)} data-testid="wa-recipient-input" />
    </F>
    <div className="border-t border-border pt-4 mt-4">
      <div className="kicker mb-2">Ingesta desde grupo de WhatsApp</div>
      <p className="text-sm text-muted-foreground mb-2">
        Reenvíe los mensajes del grupo a este webhook (desde un bot puente o automatización tipo Make/n8n):
      </p>
      <code className="block mono text-xs p-3 bg-muted overflow-x-auto">POST {webhookUrl}</code>
      <F label="Secreto del webhook">
        <Input value={s.whatsapp?.group_webhook_secret || ""} onChange={(e) => sec("whatsapp", "group_webhook_secret", e.target.value)} data-testid="wa-secret-input" />
      </F>
    </div>
    <div className="border-t border-border pt-4 mt-4">
      <div className="kicker mb-2">Noticias de WhatsApp reenviadas por correo</div>
      <p className="text-sm text-muted-foreground mb-3">
        Reenvíe los mensajes del grupo de WhatsApp al correo de la redacción. La app los
        detecta, los marca como «WhatsApp» y, si lo activa, los redacta y los deja en revisión.
      </p>
      <F label="Correos que reenvían (separados por coma)"
         hint="Ej.: prensa@gmail.com, 18091234567@whatsapp">
        <Input value={(s.ingest?.whatsapp_email_senders || []).join(", ")}
               onChange={(e) => sec("ingest", "whatsapp_email_senders",
                 e.target.value.split(",").map((v) => v.trim()).filter(Boolean))}
               data-testid="wa-email-senders-input" />
      </F>
      <F label="Palabra clave en el asunto" hint="Si el asunto la contiene, se marca como WhatsApp.">
        <Input value={s.ingest?.whatsapp_subject_hint || ""}
               onChange={(e) => sec("ingest", "whatsapp_subject_hint", e.target.value)}
               data-testid="wa-subject-hint-input" />
      </F>
      <div className="flex items-center gap-3 mb-3">
        <Switch checked={!!s.ingest?.whatsapp_auto_process}
                onCheckedChange={(v) => sec("ingest", "whatsapp_auto_process", v)}
                data-testid="wa-auto-process-switch" />
        <span className="text-sm">Redactar automáticamente y dejar en revisión</span>
      </div>
      <F label="Medios de destino de esas notas">
        <div className="flex flex-wrap gap-2">
          {(outlets || []).map((o) => {
            const on = (s.ingest?.whatsapp_outlet_ids || []).includes(o.id);
            return (
              <Button key={o.id} size="sm" variant={on ? "default" : "outline"}
                      onClick={() => sec("ingest", "whatsapp_outlet_ids",
                        on ? (s.ingest?.whatsapp_outlet_ids || []).filter((x) => x !== o.id)
                           : [...(s.ingest?.whatsapp_outlet_ids || []), o.id])}
                      data-testid={`wa-outlet-${o.id}`}>
                {o.name}
              </Button>
            );
          })}
        </div>
      </F>
      <F label="Revisar el correo automáticamente cada (minutos)"
         hint="0 desactiva la revisión automática; se usa el buzón de «Correo entrante».">
        <Input type="number" min="0" max="240"
               value={s.ingest?.email_auto_minutes ?? 0}
               onChange={(e) => sec("ingest", "email_auto_minutes", Number(e.target.value))}
               data-testid="email-auto-minutes-input" />
      </F>
    </div>
    <Button variant="outline" onClick={() => test("whatsapp")} disabled={busy === "whatsapp"} data-testid="test-whatsapp-btn">
      <PlugZap className="h-4 w-4 mr-2" />Enviar mensaje de prueba
    </Button>
  </>
);
